import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { updateCatalogSearch } from 'store/thunks/catalogThunks';

const CatalogSearchBar = () => {
  const dispatch = useDispatch();
  const search = useSelector(({ catalog }) => catalog.search);

  return (
    <TextField
      id='Catalog-Management-search-input'
      size='small'
      fullWidth
      placeholder='Search catalog by drug name'
      value={search}
      onChange={(event) => dispatch(updateCatalogSearch(event.target.value))}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <SearchIcon fontSize='small' />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CatalogSearchBar;
